import React from "react";
import { useDispatchWrapper } from "../../../../../hooks";
import { LoadState } from "../../../../../constants/enums";
import { upsertFetchDriverRecord } from "../../../../../redux/automobileDriver/automobileDriverActions";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { StatusRenderer } from "../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { useTableV2State } from "../../../../../components/TableV2/hooks/useTableV2State";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { CustomLink } from "../../../../../components/CustomLink/CustomLink";
import { DataTableV2 } from "../../../../../components/TableV2/DataTableV2";
import { fetchOpportunitesList } from "../../../../../redux/opportunites/opportunitesActions";
import { RightPanel } from "../../../../../components/RightPanel";
import { IOpportunity } from "../../../../../redux/customer/customer.types";
import { ILead } from "../../../../../models";

export interface ILeadDTableProps {
  open: boolean;
  customerId: number;
  customerPolicyId: number;
  type: string;
  onComplete: () => void;
  onClose: () => void;
}

export const LeadDialogTable: React.FC<ILeadDTableProps> = (props) => {
  const { open, onComplete, customerId, customerPolicyId, onClose, type } =
    props;
  const dispatch = useDispatchWrapper();
  const { list, totalRecords, loading } = useSelector(
    (storeState: IStoreState) => storeState.opportunites
  );

  const {
    state: {
      dateState,
      searchState,
      tabs,
      columnsConfig,
      pagination,
      masterColumnResize,
   
      dense },
    setDateState,
    setSelectedTab,
    setTableTabs,
    setSearchState,
    setColumnVisibility,
    onPageChange,
    onRowsPerPageChange,
    onResizeMasterColumns,
 
    onDenseToggle, } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "last28Days",
      selectedTab: "-1",
    },
    pagination: {
      pageNumber: 1,
      rowsInPerPage: 25,
      apiFetchRowCount: 26,
      extraFetchFactor: 1,
    },
  });

  const fetchList = () => {
    dispatch(
      fetchOpportunitesList({
        pageNumber: pagination.pageNumber,
        rowsInPerPage: pagination.rowsInPerPage,
        limit: pagination.apiFetchRowCount,
        status: tabs.selectedTab,
        date: dateState.dates,
        searchValue: searchState,
        customer_id: customerId
      })
    );
  };

    const handleClick = (leadId: any, customer_id: any) => {
    if (leadId) {
      console.log("Selected", leadId, customer_id, customerPolicyId, type);
      dispatch(
        upsertFetchDriverRecord(
          leadId,
          customerPolicyId,
          customer_id,
          type,
          (isSuccess) => {
            if (isSuccess) {
              onComplete();
            }
          }
        )
      );
    }
  };

  React.useEffect(() => {
    fetchList();
     
  }, [pagination, dateState.dates, tabs.selectedTab, searchState]);

  const leadsTableProps: IDataTableV2Props = {
    isPagination: true,
    // totalRecords: totalRecords,
    rowsPerPageOptions: pagination.rowsInPerPage,
    extraFetchFactor: pagination.extraFetchFactor,
    isDataLoading: loading !== LoadState.Loaded,
    selectionMode: "multiple",
    uniqueRowKeyName: "id",
    tableCommandBarProps: {
      preDefinedPlugins: {
        dateFilter: {
          state: dateState,
          onChange: setDateState,
        },
        search: {
          state: searchState,
          onChange: setSearchState,
          loadInitialFilterOncePopoverOpened: [
            {
              column: ["first_name"],
              logicalOperator: "OR",
              operator: "CONTAINS",
              value: "",
            },
          ],
        },
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {
        customPlugins: [],
      },
      rightItems: {
        customPlugins: [],
      },
    },
    // initialSortConfig: {
    //   insert_ts: {
    //     direction: "desc",
    //     filedName: "insert_ts",
    //   },
    // },
    masterColumns: [
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ILead) => {
          return <StatusRenderer status={row.status} />;
        },
      },

      {
        key: "first_name",
        headerName: "Name",
        fieldName: "first_name",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 15,
        enableSorting: true,

        onRowCellRender: (value, row: ILead) => {
          return (
            <CustomLink
              to={"/leads/manage/" + row.lead_id}
              label={row.first_name + " " + row.last_name}
            />
          );
        },
      },
      {
        key: "business_name",
        headerName: "Business Name",
        fieldName: "business_name",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 20,
        enableSorting: true,
      },
      {
        key: "insurance_type",
        headerName: "Quotes For",
        fieldName: "insurance_type",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 20,
        enableSorting: true,
      },
      {
        key: "insurance_sub_type",
        headerName: "Type",
        fieldName: "insurance_sub_type",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
        enableSorting: true,
      },
      {
        key: "producer_name",
        headerName: "Producer",
        fieldName: "producer_name",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 30,
        enableSorting: true,
      },

      {
        key: "insert_ts",
        headerName: "Date Created",
        fieldName: "insert_ts",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.DATE_TIME,
        // exportCellWidth: 25,
        // onExportRender: (values) => {
        //   return formatDateWithTime(values.value);
        // },
      },

      {
        key: "date",
        headerName: "Date to Contact",
        fieldName: "date",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.DATE,
        // exportCellWidth: 25,
        // onExportRender: (values) => {
        //   return values.value ? formatDateWithTime(values.value) : "--";
        // },
      },
    ],
    tableTabProps: {
      selectedTab: tabs.selectedTab,
      tabs: tabs.tabs,

      onTabChange: (newSelectedTab) => {
        setSelectedTab(newSelectedTab);
      },
    },

    rows: list,

    onPageChange: onPageChange,
    onRowsPerPageChange: onRowsPerPageChange,
    onSelection: (isAllSelected: boolean, rows: IOpportunity[]) => {
        if (rows.length > 0) {
            const leadId = rows[0].lead_id;
            const customerId = rows[0].customer_id
            if (leadId) {
                handleClick(leadId,customerId);
            }
        } 
    },
    masterColumnResize: {
      values: masterColumnResize,
      onResize: onResizeMasterColumns,
    },
      dense: dense,
    onDenseToggle: onDenseToggle,};

  return (
    <RightPanel open={open} onClose={onClose} width="80%" heading="Leads List">
      <DataTableV2 {...leadsTableProps} />
    </RightPanel>
  );
};
